import React, { useState } from 'react';

import { usePostGuideEmailRecipients } from 'features/home';
import { Trans, useTranslation } from 'react-i18next';
import { toast } from 'sonner';

export function EmailSubscriptionSection() {
  const { t } = useTranslation('home');
  const [email, setEmail] = useState('');

  const { mutate: postGuideEmailRecipients } = usePostGuideEmailRecipients();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    postGuideEmailRecipients(
      { email: email.trim() },
      {
        onSuccess: () => {
          toast.success(t('emailSubscription.successMessage'), {
            style: {
              width: '400px',
              maxWidth: '500px',
            },
          });
          setEmail('');
        },
        onError: (error) => {
          toast.error(error.message);
        },
      },
    );
  };

  return (
    <section className="relative mx-auto w-full">
      <div
        className="relative h-[446px] w-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/home/email-form.webp)',
        }}
      >
        <div className="flex h-full items-center justify-center">
          <div className="flex w-[648px] flex-col items-center gap-y-10">
            <div className="flex w-full flex-col items-center gap-y-6">
              <img
                src="/images/optimized/illusts/il_mail.webp"
                alt="email"
                className="h-[72px] w-[72px] object-cover"
              />
              <h2 className="text-center text-[32px] font-bold leading-[1.3] tracking-[-0.022em] text-[#161C2D]">
                <Trans
                  i18nKey="home:emailSubscription.title"
                  components={{ strong: <strong className="text-primary" /> }}
                />
              </h2>
            </div>

            <form onSubmit={handleSubmit} className="w-full">
              <div className="flex w-full items-center gap-x-2.5 rounded-[12px] bg-white p-3 shadow-[0px_12px_48px_0px_rgba(0,0,0,0.1)]">
                <div className="flex h-12 flex-1 items-center">
                  <input
                    type="email"
                    placeholder={t('emailSubscription.placeholder')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="h-full w-full rounded-[5px] border-none bg-transparent px-[18px] text-[20px] font-medium leading-[1.4] tracking-[-0.022em] placeholder:text-[#8E8E8E] focus:outline-none"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="flex h-auto items-center justify-center gap-x-3 rounded-[8px] bg-[#FF2D2E] px-7 py-2.5 text-[20px] font-bold leading-[1.4] tracking-[-0.022em] text-white transition-colors hover:bg-[#E02627]"
                >
                  {t('emailSubscription.button')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
